<template>
    <NuxtLayout name="default" mainClass="inside_main">

        <div class="container">
            <div class="search_section inside">
                <div class="row align-items-center">
                    <div class="col-6">
                        <div class="section_title">
                            <h1>
                                <span>{{ category ? category.name : '...' }}</span>
                            </h1>
                        </div>
                        <Breadcrumb :isContainer="false" :paths="breadcrumbPaths" />

                    </div>

                    <div class="col-6">
                        <div class="more">
                            <div class="dropdown-filter-main">
                                <button class="section_subtitle dropdown-toggle"data-bs-toggle="modal"
                                    data-bs-target="#filter_rate_modal"
                                    aria-expanded="false">
                                    <span>فلتر</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 22 20">
                                        <g transform="translate(-1 -2)">
                                        <path
                                            d="M17,5a3,3,0,1,1,3,3,3,3,0,0,1-3-3ZM2,6H14a1,1,0,0,0,0-2H2A1,1,0,0,0,2,6ZM8,9a3,3,0,0,0-2.82,2H2a1,1,0,0,0,0,2H5.18A3,3,0,1,0,8,9Zm14,2H14a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2ZM10,18H2a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Zm12,0H18.82a3,3,0,1,0,0,2H22a1,1,0,0,0,0-2Z"
                                            fill="#292d32"></path>
                                        </g>
                                    </svg>
                                    </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="search_section_wrapper">
                    <div class="row places_container" id="places_cont">

                        

                        <template v-if="Places.length > 0">

                          <PlaceObject
                            v-for="place in Places"
                            :key="place.id"
                            :filterText="filterSearchInput"
                            :place_item="place"
                          />
                          
                        </template>

                        <template v-else-if="loading">

                          <RateObjectPlaceholder v-for="n in 6" :key="n" :userShow="true" :placeShow="false" />
                        </template>

                        <div v-else class="col-md-12 text-center">
                          <div class="item_empty">
                            <p>
                                لا توجد أماكن متاحة
                          </p>
                          </div>
                        </div>
                     
                    </div>
                    <div class="moreLoading">
                    <template v-if="placesPage">
                        <a href="javascript:;" :class="{ 'loading': loading }" @click="loadMorePlaces"
                            class="section_subtitle load-more has-spinner-link">
                            <div class="button_text">عرض المزيد</div>
                        </a>
                    </template>
                </div>
                </div>
            </div>
        </div>

    <div class="modal bottomSheet userModels FilterRateModal" id="filter_rate_modal" tabindex="-1"
        aria-labelledby="filterModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header pb-0">

            </div>
            <!-- Modal Body -->
            <div class="modal-body pt-3">
              <form @submit.prevent="submitFilter">
                <div class="filter-rate-wrapper">
                  <div class="filter-head-title">
                    <h5 class="filter-title">فلترة التقييمات</h5>
                    <button @click="resetFilter" type="button" class="reset-filter">مسح الفلتر</button>
                  </div>
                  <div class="filter-body">
                    <div class="part">
                      <p class="filter_label">
                        ترتيب حسب
                      </p>
                      <div class="radio-input">
                        <label class="label">
                          <input type="radio" id="latest" v-model="filterOrder" name="value-radio" value="3">
                          <p class="text">الأحدث</p>
                        </label>

                        <label class="label">
                          <input type="radio" id="highest" v-model="filterOrder" name="value-radio" value="1">
                          <p class="text">الأعلى</p>
                        </label>

                        <label class="label">
                          <input type="radio" id="lowest" v-model="filterOrder" name="value-radio" value="4">
                          <p class="text">الأقل</p>
                        </label>

                        <label class="label">
                          <input type="radio" id="most-liked" v-model="filterOrder" name="value-radio" value="2">
                          <p class="text">الأكثر إعجاباً</p>
                        </label>
                      </div>
                    </div>
                    <!-- <div class="part">
                      <p class="filter_label">
                        تقييم يحتوي على كلمة
                      </p>

                      <div class="search_input">
                        <input class="searchInput" type="text" v-model="filterSearchInput" name="q" id="qM"
                          autocomplete="off" placeholder="بحث">
                        <button class="searchButton" type="button">
                          <svg id="vuesax_linear_search-normal" data-name="vuesax/linear/search-normal"
                            xmlns="http://www.w3.org/2000/svg" width="21.029" height="21.029"
                            viewBox="0 0 21.029 21.029">
                            <g id="search-normal">
                              <path id="Vector"
                                d="M16.648,8.324A8.324,8.324,0,1,1,8.324,0,8.324,8.324,0,0,1,16.648,8.324Z"
                                transform="translate(1.752 1.752)" fill="none" stroke="#d0d5dc" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1.7" />
                              <path id="Vector-2" data-name="Vector" d="M1.752,1.752,0,0"
                                transform="translate(17.524 17.524)" fill="none" stroke="#d0d5dc" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1.7" />
                              <path id="Vector-3" data-name="Vector" d="M0,0H21.029V21.029H0Z" fill="none"
                                opacity="0" />
                            </g>
                          </svg>
                        </button>
                      </div>
                    </div> -->
                    <button id="saveFilterButton" type="submit" class="filterSaveBtn has-spinner-link">
                      <div class="button_text">عرض</div>
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <!-- End Modal Body -->
          </div>
        </div>
      </div>
    </NuxtLayout>
</template>

<style scoped>
/* تحسين طريقة إدارة الـ breadcrumb */
.breadcrumb_wrapper {
    --bs-breadcrumb-divider: '\f10e';
}
</style>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

import Vue3StarRatings from '~/components/Vue3StarRatings.vue'
import type {
    Place
} from '~/types/types';
import {
    useRoute
} from 'vue-router';
import {
    useHead
} from '#imports';

const {
    $api
} = useNuxtApp()
const categoryRepo = categoriesRepository($api);
const placeRepo = placesRepository($api);
const route = useRoute();


// Use ref to track reviews
const filterOrder = ref(null);
const filterSearchInput = ref(null);


const Places = ref < Place[] > ([]);
const loading = ref(true);
const placesPage = ref < number | null > (null);

const categoryId = computed(() => route.params.id as string);


const { data: category, error } = await useAsyncData(`place-${categoryId.value}`, () =>
    categoryRepo.showById(categoryId.value), {
    lazy: false, // يجبر SSR على جلب البيانات عند تحميل الصفحة
  }
);

if (error.value) {
  navigateTo('/wrong', { redirectCode: 404 });

  console.error('useAsyncData Error:', error.value);
}


const currentUrl = import.meta.client ? window.location.href : useRequestURL().href;


const slugify = (text: string): string =>
    text ? text.trim().replace(/\s+/g, '-').toLowerCase() : ''

if (category.value) {



const ogTitle =  `${category.value.name} | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها`


useHead({
    link: [
        {
            rel: 'canonical',
            // Using window.location.href ensures the current URL is set as canonical.
            href: currentUrl
        }
    ],
    title: `${category.value.name}`,
    meta: [
        {
            name: 'title',
            content: ogTitle
        },
        { property: 'og:title', content: ogTitle },
        { property: 'twitter:title', content: ogTitle },
    ],

    script: [
        {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
                "@context": "https://schema.org/",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "الرئيسية",
                        "item": "https://reviewapp.sa/"  // Adjust if you have a specific home route
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "الاقسام",
                        "item": 'https://reviewapp.sa/categories'
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": category.value.name,
                        "item": currentUrl
                    }
                ]
            })
        }
    ]
});
}
// / Function to fetch category and places
const fetchData = async () => {
    try {
        await fetchPlaces(1);
    } catch (error) {
        console.error('Error fetching category or places:', error);
    }
};




const {
          closeModal
      } = useBootstrapModal("filter_rate_modal");


      
/**
 * Handle the reset filter button.
 * Resets the filter to default values, clears the search input,
 * refreshes the reviews with default filter and closes the modal.
 */
const resetFilter = async () => {
  // Reset filter selections to default values (adjust as needed)
  filterOrder.value = null           // Reset to default value "latest"
  filterSearchInput.value = null      // Clear the search input

  // Reset the reviews list and load the default reviews.
  Places.value = []
  await fetchPlaces()

  // Optionally, you might want to close the modal here as well.
  closeModal()
}

/**
 * Handle form submission by setting the filter order.
 * The filtering logic could be extended to include search parameters
 * or additional business logic.
 */
const submitFilter = async (e: Event) => {

    loading.value = true;

    Places.value = [];

    await fetchPlaces()

    loading.value = false;
    
    closeModal()
}

// Slugify function (replaces spaces with dashes)


const animateInView = () => {
  const scrolledAmount = window.scrollY;
  const bottomOfWindow = scrolledAmount + window.innerHeight;

  document.querySelectorAll('.item_rate').forEach((item) => {
    const cardTop = item.getBoundingClientRect().top + scrolledAmount;

    if (cardTop <= bottomOfWindow) {
      item.classList.add('animate');
      item.classList.remove('pre-animate');
    } else {
      item.classList.remove('animate');
      item.classList.add('pre-animate');
    }
  });
};

onMounted(async () => {
  await fetchData(); // Fetch data on page load
  animateInView(); // Run animation check on page load
  window.addEventListener('scroll', animateInView);
});

onUnmounted(() => {
  window.removeEventListener('scroll', animateInView);
});

    /**
     * Fetches places from the API with pagination.
     * @param {number} page - The page number to fetch.
     */
     const fetchPlaces = async (page = 1) => {
        try {
            const {
                data: placesData,
                nextPage: placesNextPage
            } = await placeRepo.get({
                page_count : 15,
                sort: filterOrder.value,
                name: filterSearchInput.value,
                category_id: route.params.id,
            }, page);
            if (page == 1) {
                Places.value = placesData;
            }else{
                // Append new places to the list
                Places.value = [...Places.value, ...placesData];
            }
            loading.value = false

            // Update next page reference
            placesPage.value = placesNextPage;
        } catch (error) {
            console.error("Error fetching places:", error);
        }
    };

      /**
     * Loads more places if there are additional pages available.
     */
     const loadMorePlaces = async () => {
        loading.value = true
        if (placesPage.value) {
            await fetchPlaces(placesPage.value);
        }
    };

// Build breadcrumb paths from the matched route records.
const breadcrumbPaths = computed(() => {
    return [
        {
            label: category.value ? category.value.name : '' ,
            link: ''
        }
    ];
})

</script>

<style scoped>
.item_rate .item_content h3 {
    margin-bottom: .7rem;
}
</style>
